/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Trust_Window_Warning_BodyInputs */



/**
* | output |
* | --- |
* | "While this trust window is active, this action won't require an Approve click. You'll still see what's about to happen before each operation." |
*
* @param {Chat_Tool_Trust_Window_Warning_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_warning_body = /** @type {((inputs?: Chat_Tool_Trust_Window_Warning_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_Warning_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Solange dieses Vertrauensfenster aktiv ist, braucht diese Aktion keinen Approve-Klick. Du siehst weiterhin VOR jeder Operation, was gleich passiert.")
	return /** @type {LocalizedString} */ ("While this trust window is active, this action won't require an Approve click. You'll still see what's about to happen before each operation.")
});